import { Popover } from "@shopify/polaris"
import React, { useState } from "react"
import { useTranslation } from "react-i18next"
import { SUPPORTED_LANGUAGES } from "../i18n.js"

const languageIcons = {
	en: (
		<svg
			style={{ height: "1.1rem", width: "1.1rem", display: "block" }}
			viewBox="0 0 36 36"
		>
			<path
				fill="#B22334"
				d="M35.445 7C34.752 5.809 33.477 5 32 5H18v2zM0 25h36v2H0zm18-8h18v2H18zm0-4h18v2H18zM0 21h36v2H0zm4 10h28c1.477 0 2.752-.809 3.445-2H.555c.693 1.191 1.968 2 3.445 2M18 9h18v2H18z"
			></path>
			<path
				fill="#EEE"
				d="M.068 27.679c.017.093.036.186.059.277c.026.101.058.198.092.296c.089.259.197.509.333.743L.555 29h34.89l.002-.004a4.22 4.22 0 0 0 .332-.741a3.75 3.75 0 0 0 .152-.576c.041-.22.069-.446.069-.679H0c0 .233.028.458.068.679M0 23h36v2H0zm0-4v2h36v-2H18zm18-4h18v2H18zm0-4h18v2H18zM.555 7l-.003.005zM.128 8.044c.025-.102.06-.199.092-.297a3.78 3.78 0 0 0-.092.297M18 9h18c0-.233-.028-.459-.069-.68a3.606 3.606 0 0 0-.153-.576A4.21 4.21 0 0 0 35.445 7H18z"
			></path>
			<path fill="#3C3B6E" d="M18 5H4a4 4 0 0 0-4 4v10h18z"></path>
			<path
				fill="#FFF"
				d="m2.001 7.726l.618.449l-.236.725L3 8.452l.618.448l-.236-.725L4 7.726h-.764L3 7l-.235.726zm2 2l.618.449l-.236.725l.617-.448l.618.448l-.236-.725L6 9.726h-.764L5 9l-.235.726zm4 0l.618.449l-.236.725l.617-.448l.618.448l-.236-.725l.618-.449h-.764L9 9l-.235.726zm4 0l.618.449l-.236.725l.617-.448l.618.448l-.236-.725l.618-.449h-.764L13 9l-.235.726zm-8 4l.618.449l-.236.725l.617-.448l.618.448l-.236-.725l.618-.449h-.764L5 13l-.235.726zm4 0l.618.449l-.236.725l.617-.448l.618.448l-.236-.725l.618-.449h-.764L9 13l-.235.726zm4 0l.618.449l-.236.725l.617-.448l.618.448l-.236-.725l.618-.449h-.764L13 13l-.235.726zm-6-6l.618.449l-.236.725L7 8.452l.618.448l-.236-.725L8 7.726h-.764L7 7l-.235.726zm4 0l.618.449l-.236.725l.617-.448l.618.448l-.236-.725l.618-.449h-.764L11 7l-.235.726zm4 0l.618.449l-.236.725l.617-.448l.618.448l-.236-.725l.618-.449h-.764L15 7l-.235.726zm-12 4l.618.449l-.236.725l.617-.448l.618.448l-.236-.725l.618-.449h-.764L3 11l-.235.726zM6.383 12.9L7 12.452l.618.448l-.236-.725l.618-.449h-.764L7 11l-.235.726h-.764l.618.449zm3.618-1.174l.618.449l-.236.725l.617-.448l.618.448l-.236-.725l.618-.449h-.764L11 11l-.235.726zm4 0l.618.449l-.236.725l.617-.448l.618.448l-.236-.725l.618-.449h-.764L15 11l-.235.726zm-12 4l.618.449l-.236.725l.617-.448l.618.448l-.236-.725l.618-.449h-.764L3 15l-.235.726zM6.383 16.9L7 16.452l.618.448l-.236-.725l.618-.449h-.764L7 15l-.235.726h-.764l.618.449zm3.618-1.174l.618.449l-.236.725l.617-.448l.618.448l-.236-.725l.618-.449h-.764L11 15l-.235.726zm4 0l.618.449l-.236.725l.617-.448l.618.448l-.236-.725l.618-.449h-.764L15 15l-.235.726z"
			></path>
		</svg>
	),
	es: (
		<svg
			style={{ height: "1.1rem", width: "1.1rem", display: "block" }}
			viewBox="0 0 36 36"
		>
			<path
				fill="#C60A1D"
				d="M36 27a4 4 0 0 1-4 4H4a4 4 0 0 1-4-4V9a4 4 0 0 1 4-4h28a4 4 0 0 1 4 4z"
			></path>
			<path fill="#FFC400" d="M0 12h36v12H0z"></path>
			<path fill="#EA596E" d="M9 17v3a3 3 0 1 0 6 0v-3z"></path>
			<path fill="#F4A2B2" d="M12 16h3v3h-3z"></path>
			<path fill="#DD2E44" d="M9 16h3v3H9z"></path>
			<ellipse cx="12" cy="14.5" fill="#EA596E" rx="3" ry="1.5"></ellipse>
			<ellipse
				cx="12"
				cy="13.75"
				fill="#FFAC33"
				rx="3"
				ry=".75"
			></ellipse>
			<path fill="#99AAB5" d="M7 16h1v7H7zm9 0h1v7h-1z"></path>
			<path
				fill="#66757F"
				d="M6 22h3v1H6zm9 0h3v1h-3zm-8-7h1v1H7zm9 0h1v1h-1z"
			></path>
		</svg>
	),
	fr: (
		<svg
			style={{ height: "1.1rem", width: "1.1rem", display: "block" }}
			viewBox="0 0 36 36"
		>
			<path
				fill="#ED2939"
				d="M36 27a4 4 0 0 1-4 4h-8V5h8a4 4 0 0 1 4 4z"
			></path>
			<path
				fill="#002495"
				d="M4 5a4 4 0 0 0-4 4v18a4 4 0 0 0 4 4h8V5z"
			></path>
			<path fill="#EEE" d="M12 5h12v26H12z"></path>
		</svg>
	),
	nl: (
		<svg
			style={{ height: "1.1rem", width: "1.1rem", display: "block" }}
			viewBox="0 0 36 36"
		>
			<path fill="#EEE" d="M0 14h36v8H0z"></path>
			<path
				fill="#AE1F28"
				d="M32 5H4a4 4 0 0 0-4 4v5h36V9a4 4 0 0 0-4-4"
			></path>
			<path
				fill="#20478B"
				d="M4 31h28a4 4 0 0 0 4-4v-5H0v5a4 4 0 0 0 4 4"
			></path>
		</svg>
	),
	de: (
		<svg
			style={{ height: "1.1rem", width: "1.1rem", display: "block" }}
			viewBox="0 0 36 36"
		>
			<path
				fill="#FFCD05"
				d="M0 27a4 4 0 0 0 4 4h28a4 4 0 0 0 4-4v-4H0z"
			></path>
			<path fill="#ED1F24" d="M0 14h36v9H0z"></path>
			<path
				fill="#141414"
				d="M32 5H4a4 4 0 0 0-4 4v5h36V9a4 4 0 0 0-4-4"
			></path>
		</svg>
	),
	it: (
		<svg
			style={{ height: "1.1rem", width: "1.1rem", display: "block" }}
			viewBox="0 0 36 36"
		>
			<path
				fill="#CE2B37"
				d="M36 27a4 4 0 0 1-4 4h-8V5h8a4 4 0 0 1 4 4z"
			></path>
			<path
				fill="#009246"
				d="M4 5a4 4 0 0 0-4 4v18a4 4 0 0 0 4 4h8V5z"
			></path>
			<path fill="#EEE" d="M12 5h12v26H12z"></path>
		</svg>
	),
}

export const LanguageSelector = () => {
	const { i18n } = useTranslation()
	const [showPopover, setShowPopover] = useState(false)

	const changeLanguage = (lang) => {
		i18n.changeLanguage(lang)
		setShowPopover(false)
	}

	const currentLanguageName = new Intl.DisplayNames(i18n.language, {
		type: "language",
	}).of(i18n.language)

	return (
		<div
			className="border shadow"
			style={{
				borderRadius: "0.5rem",
				padding: "0.2rem 0.5rem",
				background: "#fff",
				color: "#333",
				cursor: "pointer",
				display: "flex",
				gap: "0.3rem",
				alignItems: "center",
			}}
			onClick={() => setShowPopover(!showPopover)}
		>
			<span style={{ fontSize: "1.2rem" }}>
				{languageIcons[i18n.language]}
			</span>
			<span
				className="email"
				style={{
					fontSize: "1rem",
					fontWeight: "500",
					textTransform: "capitalize",
				}}
			>
				{currentLanguageName}
			</span>

			<Popover
				active={showPopover}
				onClose={() => setShowPopover(false)}
				preferredPosition="below"
				preferredAlignment="right"
				zIndexOverride="550"
				activator={
					<div
						style={{
							cursor: "pointer",
							background: "transparent",
							display: "flex",
							alignItems: "center",
						}}
						onClick={() => setShowPopover(!showPopover)}
					>
						<svg
							xmlns="http://www.w3.org/2000/svg"
							width="1.25rem"
							height="1.25rem"
							viewBox="0 0 24 24"
						>
							<path
								fill="currentColor"
								d="m12 15l-5-5h10l-5 5Z"
							></path>
						</svg>
					</div>
				}
			>
				<div
					style={{
						padding: "0.2rem",
						display: "flex",
						flexDirection: "column",
						gap: "0.2rem",
					}}
				>
					{SUPPORTED_LANGUAGES.map((lang) => {
						const languageName = new Intl.DisplayNames(lang, {
							type: "language",
						}).of(lang)

						return (
							<div
								key={lang}
								className="language-option"
								onClick={() => changeLanguage(lang)}
							>
								{languageIcons[lang]}
								<span
									style={{
										fontSize: "0.9rem",
										fontWeight: "500",
										textTransform: "capitalize",
									}}
								>
									{languageName}
								</span>
							</div>
						)
					})}
				</div>
			</Popover>

			<style>{`
				.language-option {
					display: flex;
					gap: 0.3rem;
					align-items: center;
					padding: 0.1rem 0.3rem;
					border-radius: 0.3rem;
					cursor: pointer;
				}
				.language-option:hover {
					background: #eee;
				}
			`}</style>
		</div>
	)
}
